import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AGREEMENT_STATE } from 'Pages/orders_design'

interface InitialState {
	agreementState: AGREEMENT_STATE
}

const initialState: InitialState = {
	agreementState: AGREEMENT_STATE.ACTUAL,
}

export const leadUiSlice = createSlice({
	name: 'leadUi',
	initialState,
	reducers: {
		setAgreementState: (state, action: PayloadAction<AGREEMENT_STATE>) => {
			state.agreementState = action.payload
		},
	},
})
